export const HomeLinks: Record<string, string> = {
    "EN": "/",
    "BG": "/bg/nachalo",
    "MK": "/mk/pochetna-strana/"
}